import * as React from 'react';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { KmxSearchStroked } from '@kmx/mui-icons';
import Paper from '@mui/material/Paper';
import Carousel from './Carousel';
import { MuiSkeletonVehicleTile } from './MUISkeletonVehicleTile';
import Typography from '@mui/material/Typography';

export const RecentlyViewedPlaceholderCarousel: React.FC = () => {
    return (
        <div className="home-base-hero--tab-placeholder home-base-hero--viewed-tab-placeholder">
            <ul className="tab-placeholder--list kmx-list">
                <Carousel
                    name="viewed-placeholder"
                    nextFocus="#budget-calculator-section"
                    ariaLabel="No Viewed Vehicles Available"
                >
                    <li className="tab-placeholder--list-item carousel__slide" key="viewed-placeholder-tile-1">
                        <Paper
                            sx={{
                                padding: { xs: 4, lg: 5 },
                                display: 'flex',
                                flexDirection: 'column',
                            }}
                            className="carousel-slide-item"
                        >
                            <Stack gap={3}>
                                <Stack>
                                    <Box>
                                        <KmxSearchStroked sx={{ fontSize: '56px' }} />
                                    </Box>
                                    <Typography variant="h5">Nothing feeling quite right?</Typography>
                                </Stack>
                                <Button color="primary" variant="outlined" size="medium" href="/cars">
                                    Browse for cars
                                </Button>
                            </Stack>
                        </Paper>
                    </li>
                    <li
                        className="tab-placeholder--list-item tab-placeholder--skeleton carousel__slide"
                        key="viewed-placeholder-tile-2"
                    >
                        <MuiSkeletonVehicleTile />
                    </li>
                    <li
                        className="tab-placeholder--list-item tab-placeholder--skeleton carousel__slide"
                        key="viewed-placeholder-tile-3"
                    >
                        <MuiSkeletonVehicleTile />
                    </li>
                    <li
                        className="tab-placeholder--list-item tab-placeholder--skeleton carousel__slide"
                        key="viewed-placeholder-tile-4"
                    >
                        <MuiSkeletonVehicleTile />
                    </li>
                </Carousel>
            </ul>
        </div>
    );
};
